import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Fi-Fi/Life Saving Equipment',
  items: [
    {
      title: 'Breathing Apparatuses',
      hasMaker: true,
      hasType: true,
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'CO2 System',
      hasMaker: true,
      hasType: true,
      makers: ['Johnson Controls - Tyco', 'NK', 'Kawasaki', 'Fain', 'Danfoss'],
      standardServices: [
        {
          title: 'Biennial Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '10 Year Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Dry Powder System',
      hasMaker: true,
      hasType: true,
      makers: ['Johnson Controls - Tyco', 'NK', 'Fain'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'EEBDs',
      hasMaker: true,
      hasType: true,
      makers: ['Survitec'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Emergency Fire Pump',
      hasMaker: true,
      hasType: true,
      standardServices: [
        {
          title: 'Overhauling/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Fire Detection System',
      hasMaker: true,
      hasType: true,
      makers: ['Consilium', 'Autronica', 'B-I Industry', 'Survitec'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Control System Troubleshooting',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Fire Pump',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Fireman Outfits',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Foam System',
      hasMaker: true,
      hasType: true,
      standardServices: [
        {
          title: 'Foam Analysis',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Mixing Valve Testing',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Immersion Suits',
      hasMaker: true,
      hasType: true,
      makers: ['Survitec'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Hydrotesting',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Life Boat Davits',
      hasMaker: true,
      hasType: true,
      makers: [
        'Hyundai',
        'Oriental',
        'Norsafe',
        'Macgregor',
        'Survitec',
        'Hatecke',
        'ACEBI',
        'Palfinger',
        'Mansei',
        'Sekigahara Seisakusho',
        'Jiangsu Jiaoyan',
        'QINGDAO BEIHAI',
      ],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Load Testing',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Lifeboat Oxygen',
      hasMaker: true,
      hasType: true,
      makers: ['QINGDAO BEIHAI'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Lifeboat/Rescue Boat',
      hasMaker: true,
      hasType: true,
      makers: [
        'Hyundai',
        'Oriental',
        'Norsafe',
        'Macgregor',
        'Survitec',
        'Hatecke',
        'ACEBI',
        'Palfinger',
        'Shigi',
        'Jiangsu Jiaoyan',
        'QINGDAO BEIHAI',
      ],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Liferafts',
      hasMaker: true,
      hasType: true,
      makers: ['Viking', 'Survitec', 'Fujikura'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Exchange',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Medical Oxygen',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Portable Fire Extinguishers',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Portable Gas Detectors',
      hasMaker: true,
      hasType: true,
      standardServices: [
        {
          title: 'Annual Calibration',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Water Spray System',
      hasMaker: true,
      hasType: true,
      makers: ['Johnson Controls - Tyco', 'NK', 'Fain', 'Softex', 'Seaplus'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
